import * as Sentry from "@sentry/react";
import { UserInterface } from "@/features/Auth/LoginForm/Interfaces/UserInterface";
import { convertOjectToReadableJson } from "./convertOjectToReadableJson";

export interface ErrorDataInterface {
    errorTitle?: string,
    originalError: unknown,
    user?: UserInterface,
    http?: {
        url?: string,
        method?: string,
        payload?: string | unknown,
    },
    state?: any,
}

export function captureError(error: ErrorDataInterface) {
    let customError: null | Error = null;
    if (error.errorTitle !== undefined) {
        customError = new Error(error.errorTitle);
    }
    
    Sentry.withScope( (scope: any) => {
        scope.setExtra('Original error', error.originalError);
        scope.setExtra('Original error as JSON', convertOjectToReadableJson(error.originalError) );

        if (error.http !== undefined) {
            scope.setExtra('Http method', error.http.method);
            scope.setExtra('Api url', error.http.url);
            if (error.http.payload !== undefined) {
                scope.setExtra('Payload', error.http.payload);
            }
        }

        if (error.state !== undefined) {
            scope.setExtra('State', convertOjectToReadableJson(error.state) );
        }

        // Добавление тегов для фильтрации и категоризации
        // scope.setTag('feature', 'user-auth');
        // scope.setTag('environment', 'production');

        if (error.user !== undefined) {
            scope.setUser({
                id: error.user.id,
                email: error.user.email,
            });

            const userObj = {
                id: error.user.id,
                email: error.user.email,
                roles: error.user.roles.map(unit => unit.title).join(", "),
            }
            scope.setExtra('User', userObj);
        }

        if (customError !== null) {
            Sentry.captureException(customError);
        } else {
            Sentry.captureException(error.originalError);
        }
    });
}